

export default function useLogout(options) {

    const { onlyUserToken = false } = options || {}

    const logout = async () => {
        localStorage.removeItem("token")
        if (!onlyUserToken) {
            localStorage.removeItem("admin_token")
            localStorage.removeItem("agency_token")
        }
        window.location.reload(); //await userMutate(null)
    }

    return logout
}